import { FC, useEffect, useRef, useState } from "react";
import FlexBox from "../flex-box";
import SimpleCard from "../simple-card";
import { PiPlusBold } from "react-icons/pi";
import SimpleDocPreviewer from "./simple-doc-previewer";
import { DMSServices } from "lib/services/document-services";

interface SimpleDocUploaderProps {
  mode?: "single" | "multiple";
  type?: "image" | "video" | "audio" | "document";
  doc?: File;
  docUrl?: string;
  className?: string;
  onChange?: (files: File[]) => void;
  onDelete?: () => void;
}

const SimpleDocUploader: FC<SimpleDocUploaderProps> = ({
  mode = "single",
  doc,
  docUrl,
  className,
  onChange,
  onDelete,
  type = "image",
}) => {
  const hiddenFileInputRef = useRef<HTMLInputElement>(null);
  const [selectedProfilePicUrl, setSelectedProfilePicUrl] = useState<
    string | null
  >(docUrl);
  const [currentDoc, setCurrentDoc] = useState<File | null>(doc);

  useEffect(() => {
    setSelectedProfilePicUrl(docUrl);
    if (docUrl) {
      DMSServices.getDocumentFromUrl(docUrl, "document").then((file) =>
        setCurrentDoc(file)
      );
    } else if (doc) {
      setCurrentDoc(doc);
    } else {
      setCurrentDoc(null);
    }
  }, [docUrl, doc]);

  // useEffect(() => {
  //   setCurrentDoc(doc);
  // }, [doc]);

  if (doc || selectedProfilePicUrl) {
    return (
      <SimpleDocPreviewer
        doc={currentDoc}
        docUrl={selectedProfilePicUrl}
        onDelete={onDelete}
      />
    );
  }

  return (
    <SimpleCard
      className={`doc-uploader cursor-pointer hover-primary ${className}`}
      bg="light-bg"
      onClick={() => hiddenFileInputRef.current?.click()}
    >
      <FlexBox justifyContent="center" alignItems="center" className="h-100">
        <PiPlusBold size="128px" className="" />
        <input
          className="d-none"
          type="file"
          accept={
            type === "image"
              ? "image/*"
              : type === "video"
              ? "video/*"
              : type === "audio"
              ? "audio/*"
              : "application/pdf"
          }
          id="hidden-file-input"
          ref={hiddenFileInputRef}
          onChange={(e) => {
            //e.preventDefault();
            e.stopPropagation();
            const files = e.target.files;
            if (files && files.length > 0) {
              const selectedFiles = Array.from(files);
              if (mode === "single") {
                onChange?.([selectedFiles[0]]);
              } else {
                onChange?.(selectedFiles);
              }
            }
          }}
        />
      </FlexBox>
    </SimpleCard>
  );
};

export default SimpleDocUploader;
